import { render, staticRenderFns } from "./DynamicChildReg.vue?vue&type=template&id=5699bf15&"
import script from "./DynamicChildReg.vue?vue&type=script&lang=js&"
export * from "./DynamicChildReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports